import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useApp } from "../../context/App";
import { api, urls } from "../../services/api";
import { TitlePage } from "../../components/ui/TitlePage";
import { ListFiles } from "../../components/ui/ListFiles";
import { Helmet } from "react-helmet-async";
import { IFileItem } from "../../types/file";
import { ChevronLeft, FileText } from "lucide-react";
import { ShareSection } from "../../components/ui/ShareSection";

export function FilesScreen() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { mobile } = useApp();
    const [files, setFiles] = useState<IFileItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [title, setTitle] = useState("Arquivos");

    useEffect(() => {
        (async () => {
            try {
                const response = await api.get(urls.ArquivoDownload + id);

                let filesData: IFileItem[] = [];

                if (Array.isArray(response.data)) {
                    filesData = response.data.map((item: any) => ({
                        titulo: item.titulo,
                        url: item.caminho
                    }));
                }
                else if (response.data.arquivos) {
                    filesData = response.data.arquivos.map((item: any) => ({
                        titulo: item.titulo,
                        url: item.caminho || item.url
                    }));
                    setTitle(response.data.titulo || "Arquivos");
                }

                setFiles(filesData);
            } catch (error) {
                // error silent
            } finally {
                setLoading(false);
            }
        })();
    }, [id]);

    return (
        <div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors items-center justify-start pb-20">
            <Helmet>
                <title>{title} | Município de Itajaí</title>
            </Helmet>

            {mobile && <div className="h-20" />}

            <div className="w-11/12 lg:w-3/5 mt-8">
                {/* Header Actions */}
                <div className="flex items-center justify-between mb-2">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-1.5 text-on-surface-subtle dark:text-on-surface-dark-muted hover:text-primary dark:hover:text-secondary transition-colors font-bold uppercase text-[10px] tracking-widest border-none bg-transparent cursor-pointer"
                    >
                        <ChevronLeft size={16} strokeWidth={3} />
                        Voltar
                    </button>
                </div>

                <TitlePage title={title.toUpperCase()} />

                {loading ? (
                    <div className="flex flex-col items-center justify-center py-24 gap-4 animate-pulse">
                        <FileText className="text-secondary opacity-20" size={48} />
                        <span className="text-on-surface-subtle font-medium uppercase tracking-widest text-xs">Carregando arquivos...</span>
                    </div>
                ) : (
                    <div className="mt-10">
                        {files.length > 0 ? (
                            <>
                                <div className="bg-surface-alt/20 dark:bg-surface-dark-alt/20 rounded-3xl p-6 lg:p-8 border border-border-default/50 dark:border-border-default-dark/50 shadow-sm">
                                    <ListFiles files={files} />
                                </div>
                                <ShareSection
                                    title="Compartilhar Pasta"
                                    subtitle="Envie esta lista de arquivos para alguém"
                                    className="mt-16"
                                />
                            </>
                        ) : (
                            <div className="flex flex-col items-center py-20 gap-4">
                                <FileText className="text-border-default dark:text-border-default-dark" size={48} />
                                <span className="text-on-surface-subtle font-bold uppercase tracking-widest text-xs">Nenhum arquivo encontrado nesta pasta.</span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
